import React from 'react';
import './FooterLink.less';
import {FooterCaption} from "elements/footer-caption/FooterCaption";

export const FooterLink = ({url, text}) => {
	return <a className="footer-link" href={url} target="_blank">
		<FooterCaption text={text}/>
	</a>
}
